var enLang = {
	"Chọn": "Select"
};

export { enLang as default };
